import script from "./Books.vue?vue&type=script&setup=true&lang=js"
export * from "./Books.vue?vue&type=script&setup=true&lang=js"

import "./Books.vue?vue&type=style&index=0&id=b3d79754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d79754"]])

export default __exports__